const createAvatar = (firstname: string | undefined, lastname: string | undefined) =>
  ((firstname || '').charAt(0) + (lastname || '').charAt(0)).toUpperCase();

export default createAvatar;
